import React, { useEffect, useState, useMemo, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SafariPackagesFilters from "../view/SafariPackagesFilters";
import apiCall from "../../Api/api";
import SelectedFilters from "../view//SelectedFilters";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import { useMasterContext } from "../../../provider/MasterProvider";
import SafariPackageCardSkeleton from "components/common/Skeleton/packages/SafariPackageCardSkeleton";
import SafariPackageCard from "../view/SafariPackageCard";
import { useScreenSize } from "provider/ScreenSizeProvider";
import SafariPackageMobileFilter from "../view/SafariPackageMobileFilter";
import { common } from "Data/common";


const SafariPackage = () => {
  const { safariPackagesData, summary, filters, pageIndex, safariPackagesDispatch } = useSafariPackagesContext();
  const { safariPackSortBy, masterLoading } = useMasterContext();
  const [loading, setLoading] = useState(true);
  const [error,] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const { isMobileView } = useScreenSize();
   const isFetchingRef = useRef(false);

  const PACKAGE = common?.SAFARI_PACKAGE?.MAIN;


  const handleFilterClick = () => {
    setShowFilter(true);
  };

  useEffect(() => {
    const fetchSafariPackages = async () => {
      setLoading(true)
      try {
        const queryParams = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
          if (
            Array.isArray(value) && value.length > 0
          ) {
            value.forEach(v => queryParams.append(`${key}[]`, v));
          } else if (value !== 0 && value !== null && value !== "") {
            queryParams.append(key, value);
          }
        });

        if (summary?.pageSize) {
          queryParams.append("pageSize", summary.pageSize);
        }
        if (pageIndex) {
          queryParams.append("page", pageIndex);
        }


        const response = await apiCall({
          url: `package?${queryParams.toString()}`,
          method: "GET",
        });
        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            // Dynamically set errors based on the response
            console.error(errors)
          } else {
            const postData = response?.data?.packages?.data || [];
            const summary = response?.data?.packages?.summary;
            if (pageIndex === 1) {
              safariPackagesDispatch({ type: 'SET_SAFARI_PACKAGES_DATA', payload: postData });
            } else {
              safariPackagesDispatch({ type: 'APPEND_SAFARI_PACKAGES_DATA', payload: postData });
            }

            safariPackagesDispatch({
              type: 'SAFARI_PACKAGES_SUMMARY', payload: {
                "total": summary.total,
                "page": summary.page,
                "pageSize": summary.pageSize,
                "total_page": summary.total_page,
              }
            });
          }
        }

      } catch (err) {
        console.error("Error fetching safaris:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSafariPackages();
  }, [summary?.pageSize, filters, pageIndex]);


  const processedSafariPackages = useMemo(() => {
    return safariPackagesData?.map((packages) => ({
      ...packages
    }));
  }, [safariPackagesData, pageIndex]);



  const handleSortChange = (e) => {
    safariPackagesDispatch({ type: "SAFARI_PACKAGES_PAGE_INDEX", payload: 1 });
    const value = Number(e.target.value);
    updateFilter("custom_sort_by", value);
  };
  const updateFilter = (name, value) => {
    safariPackagesDispatch({
      type: "UPDATE_SAFARI_PACKAGES_FILTER",
      payload: { [name]: value },
    });
  };

  useEffect(() => {
      const handleScroll = () => {
        const scrollPosition = window.innerHeight + window.scrollY;
        const threshold = document.body.offsetHeight - 500; // Trigger when 200px near bottom
  
        if (
          scrollPosition >= threshold &&
          !loading &&
          summary?.page < summary?.total_page &&
          !isFetchingRef.current
        ) {
          isFetchingRef.current = true; // Avoid multiple triggers
          safariPackagesDispatch({
            type: "SAFARI_PACKAGES_PAGE_INDEX",
            payload: pageIndex + 1,
          });
        }
      };
  
      window.addEventListener("scroll", handleScroll, { passive: true });
      return () => window.removeEventListener("scroll", handleScroll);
    }, [loading, pageIndex, summary?.page, summary?.total_page]);
  
    useEffect(() => {
      isFetchingRef.current = false;
    }, [safariPackagesData]);

  return (
    <>
      {/* --- Banner Section --- */}
      <section className="banner_section-inner packagebnner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/baneer1719164625.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
        <div className="banner_searchBox">
          <Container>
            <Row>
              <Col>
                <div className="headingBnner_inner">
                  <h1>{PACKAGE?.TITLE}</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* --- Safari List Section --- */}
      <section className="articals_wrapper py-3 px-md-5 px-xl-0 px-3">

        <Row className="justify-content-center my-4 margin_bottomfooter">
          <Col xl={12} xxl={10} lg={12}>
            <Row className=" justify-content-center">
              <Col lg={3} xl={2} xxl={2} className="ps-lg-0 mb-4">
                {!isMobileView && <SafariPackagesFilters />}

                {isMobileView && <div
                  id="targetDiv"
                  className="mobileDive"
                  style={{ display: showFilter ? "block" : "none" }}
                >
                  <SafariPackageMobileFilter onCancel={() => setShowFilter(false)} />
                </div>
                }
              </Col>
              {isMobileView && <Col xs={12} className="px-0 d-lg-none">
                <div className="top_mobilefilter d-flex gap-2  justify-content-between align-items-center w-100 mb-4">
                  <div className="left_text">
                    <p className="mb-0">
                      {PACKAGE?.SAFARI_TEXT_1}{" "}
                      <strong> {summary?.total || 0} </strong>
                      {PACKAGE?.SAFARI_TEXT_2}
                    </p>
                  </div>
                  <div className="right-select mobile_serach mb-md-0 ">
                    <div class="input_check pb-0">
                      <div class="filter_searchbox" onClick={handleFilterClick}>
                        <span> {PACKAGE?.FILTER_TEXT} <i class="fa-solid fa-chevron-down"></i></span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              }

              <Col lg={9} xl={9} xxl={9} className="bg-whitesetnew pt-3" >
                <Row>
                  {!isMobileView && <Col xs={12}>
                    <div className="topfilter d-lg-flex d-none justify-content-between align-items-center flex-wrap w-100 mb-2">
                      <div className="left_text">
                        <p className="mb-0">
                          {PACKAGE?.SAFARI_TEXT_1}{" "}
                          <strong> {summary?.total || 0} </strong>
                          {PACKAGE?.SAFARI_TEXT_2}
                        </p>
                      </div>
                      <div className="right-select">
                        <div className="input_check pb-0 mb-3">
                          <div className="form-group field-packagesearch-custom_sort_by">
                            <select
                              id="packagesearch-custom_sort_by"
                              className="form-control custom_sort_by_input"
                              name="custom_sort_by"
                              value={filters?.custom_sort_by}
                              onChange={handleSortChange}
                              style={{ minWidth: "150px" }}
                            >

                              {Array.isArray(safariPackSortBy) && safariPackSortBy?.length > 0 ? (
                                safariPackSortBy?.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))) : masterLoading ? (
                                  <option key={"1"} value={""}>
                                    {"Sort By     "}
                                  </option>
                                ) : (
                                <p>{PACKAGE?.NO_FILTER}</p>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  }
                  <SelectedFilters />
                </Row>

                {/* Safari Cards */}
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-3 g-lg-3 gx-lg-4 gx-xxl-4 pt-1 row">
                  {error && <p className="text-danger">{error}</p>}

                  {(Array.isArray(processedSafariPackages) && processedSafariPackages?.length > 0) ? (
                    processedSafariPackages.map((safariPackages, index) => (
                      <Col
                        className="mb-xl-2 mb-md-2 mb-3 padding_righ"
                        key={safariPackages.id || index}
                      >
                        <SafariPackageCard safariPackages={safariPackages} />
                      </Col>
                    ))
                  ) : loading ? (
                    <SafariPackageCardSkeleton count={6} />
                  ) : (
                    <p>{PACKAGE?.NO_PACKAGE}</p>
                  )}
                </Row>

                <div className="d-flex justify-content-center my-4">
                  {loading ? (
                    <div
                      className="spinner-border loading-spinner"
                      role="status"
                    >
                      <span className="visually-hidden">{PACKAGE?.LOAD_MORE}</span>
                    </div>
                  ) : (
                    summary?.page < summary?.total_page && (
                      <>
                      {/* <button
                        className="join_btn newbgjoin mt-sm-0 mt-2"
                        onClick={() => {

                          const nextPage = pageIndex + 1
                          safariPackagesDispatch({
                            type: "SAFARI_PACKAGES_PAGE_INDEX",
                            payload: nextPage,
                          });

                        }}
                      >
                        {PACKAGE?.MORE_PACKAGE_BUTTON}
                      </button> */}
                      </>
                    )
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

      </section>
    </>
  );
};

export default SafariPackage;
